import { reset } from 'dragscroll'

document.addEventListener('turbo:load', () => {
  // note: 本来不要だが turbo 用に
  reset()
})
